<template>
  <video class="video" :src="video_url" controls="controls">
    您的浏览器不支持 video 标签。
  </video>
</template>

<script>
export default {
  name: 'Player',
  data() {
    return {
      video_url:
        'http://content-pic2.oss-cn-shanghai.aliyuncs.com/1603011385933.mp4',
    };
  },
};
</script>

<style scoped>
.video {
  width: 100vw;
  height: 100vh;
}
</style>
